export enum MollieRefundStatus {
    Queued = "queued",
    Pending = "pending",
    Processing = "processing",
    Refunded = "refunded",
    Failed = "failed",
    Canceled = "canceled"
}
